import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TooltipModule } from '@libs/ui-lib';
import { routes } from '@libs/utils';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { PushTagOnClickDirective, TagEvent } from '@libs/shared-services';

@Component({
  selector: 'lib-patient-item-actions',
  templateUrl: './patient-item-actions.component.html',
  imports: [SvgIconComponent, RouterModule, TooltipModule, TranslateModule, PushTagOnClickDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PatientItemActionsComponent {
  @Input() public patientId!: string;

  protected routes = routes;
  protected TagEvent = TagEvent;
}
